<ion-content>
  <div class="signup-wrapper">
    <div class="logo-container">
      <img src="https://storage.googleapis.com/nutritionambition.app/logos/login-screen-logo.svg" alt="Nutrition Ambition Logo" class="signup-logo clickable-logo" (click)="navigateToChat()" />
    </div>
    <div class="signup-card">
      <h1 class="form-title">Sign up</h1>
      <p class="beta-message">Thanks for joining us! </p>
      <p class="beta-message">We’re excited to support your with your health and nutrition goals.</p>

      <form (ngSubmit)="onSignup()">
        <div class="form-group">
          <label for="email" class="input-label">Email</label>
          <ion-input
            id="email"
            type="email"
            [(ngModel)]="email"
            name="email"
            class="input-box"
            required>
          </ion-input>
        </div>
        
        <div class="form-group">
          <label for="password" class="input-label">Password</label>
          <ion-input
            id="password"
            type="password"
            [(ngModel)]="password"
            name="password"
            class="input-box"
            required>
            <ion-input-password-toggle slot="end" color="medium"></ion-input-password-toggle>
          </ion-input>
        </div>
        
        <div class="form-group">
          <label for="confirmPassword" class="input-label">Confirm Password</label>
          <ion-input
            id="confirmPassword"
            type="password"
            [(ngModel)]="confirmPassword"
            name="confirmPassword"
            class="input-box"
            required>
            <ion-input-password-toggle slot="end" color="medium"></ion-input-password-toggle>
          </ion-input>
        </div>

        <div class="terms-checkbox-container">
          <ion-checkbox [(ngModel)]="termsAccepted" name="termsAccepted" labelPlacement="end">
            <span class="terms-text"><span class="terms-line">I agree to the <a routerLink="/legal/terms-of-service" class="legal-link">Terms of Use</a></span> <span class="terms-line"> and <a routerLink="/legal/privacy-policy" class="legal-link">Privacy Policy</a></span></span>
          </ion-checkbox>
        </div>

        <div class="terms-checkbox-container">
          <ion-checkbox [(ngModel)]="marketingOptIn" name="marketingOptIn" labelPlacement="end">
            <span class="terms-text">
                <div>Send me helpful reminders to log</div>
                <div> my meals and nutrition inspiration</div>
          </span>
          
          </ion-checkbox>
        </div>

        <ion-button expand="block" type="submit" color="tertiary" class="signup-button" [disabled]="isWorking || !termsAccepted">
          {{ isWorking ? 'Creating Account...' : 'Sign up' }}
        </ion-button>

        <ion-button expand="block" class="guest-login-button" [disabled]="isWorking" (click)="onContinueAsGuest()">
          Continue as Guest
        </ion-button>
      </form>
      
      <div class="form-footer">
        <a routerLink="/login" class="form-footer-link">Already have an account? Log in!</a>
      </div>
    </div>
    
    <div class="copyright-text">
      Copyright © 2025–{{ currentYear }} Nutrition Ambition All rights reserved
    </div>
  </div>
</ion-content> 